import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateMealTierEntity } from '../../domain/entities/CreateUpdateMealTierEntity'

export class CreateUpdateMealTierModel extends CreateUpdateMealTierEntity {
  constructor(dataEntity: CreateUpdateMealTierEntity) {
    super()
    mapEntityProperties<CreateUpdateMealTierEntity>(this, dataEntity)
  }
}
